import { Link } from 'react-router-dom';
import '../styles/page.css';
import { useEffect, useState } from 'react';
import { IDocumentList } from '../../interface/document';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Pagination from 'components/Pagination';

function Document() {
  const [documentList, setDocumentList] = useState<IDocumentList[]>();
  const [searchDocumentTitle, setSearchDocumentTitle] = useState(''); // 자료실 제목 검색

  // 페이징처리 관련
  const [currentPageDocument, setCurrentPageDocument] = useState<IDocumentList[]>();
  const itemsPerPage = 10;
  const totalItems =
    documentList?.length === 0 || undefined === documentList ? 1 : documentList?.length;

  /**
   * 검색 조건: 자료실 제목 변경 시 이벤트
   */
  const handleChangeDocumentTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case 'searchDocumentTitle':
        setSearchDocumentTitle(event.target.value);
        break;

      default:
        break;
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    await fetch(`/document/list?searchTitle=${searchDocumentTitle}`, {
      method: 'GET',
      headers: { 'Content-Type': 'applications/json' },
    })
      .then((response) => response.json())
      .then((result) => {
        setDocumentList(result);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  const handlePageChange = (page: number) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setCurrentPageDocument(documentList?.slice(startIndex, endIndex));
  };

  // 첨부파일 개별 다운로드 >>> .crdownload 문제때문에 fetch 방식으로 변경
  // const handleFileDownload = async (attachCd: string | undefined) => {
  //   const documentInfo = documentList?.filter((item) => item.boardAttach === attachCd);
  //   if (documentInfo) {
  //     const fileInfo = documentInfo[0]?.attachFiles;
  //     if (fileInfo) {
  //       const param = encodeURIComponent(JSON.stringify(fileInfo));
  //       window.location.href = `/common/fileDownload?fileList=${param}`;
  //     }
  //   }
  // };

  const handleFileDownload = async (attachCd: string | undefined) => {
    if (!attachCd) return;

    // 1. 해당 첨부코드에 해당하는 파일 리스트 조회
    const documentInfo = documentList?.find((item) => item.boardAttach === attachCd);
    const fileInfo = documentInfo?.attachFiles;

    if (!fileInfo || fileInfo.length === 0) return;

    // 2. 단건만 보낼 것이므로 첫 번째 파일만 추출
    const singleFileInfo = [fileInfo[0]]; // 배열 유지
    const param = encodeURIComponent(JSON.stringify(singleFileInfo));
    const fileUrl = `/common/fileDownload?fileList=${param}`;
    const fileName = fileInfo[0].fileNm as string;

    try {
      const response = await fetch(fileUrl, { method: 'GET' });

      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      alert('파일 다운로드에 실패했습니다.');
    }
  };

  // 첨부파일 일괄 다운로드 >>> .crdownload 문제때문에 fetch 방식으로 변경
  // const handleZipDownload = async (attachCd: string | undefined) => {
  //   const documentInfo = documentList?.filter((item) => item.boardAttach === attachCd);
  //   if (documentInfo) {
  //     const fileInfo = documentInfo[0]?.attachFiles;
  //     if (fileInfo) {
  //       const param = encodeURIComponent(JSON.stringify(fileInfo));
  //       window.location.href = `/common/zipDownload?fileList=${param}`;
  //     }
  //   }
  // };

  const handleZipDownload = async (attachCd: string | undefined) => {
    const documentInfo = documentList?.find((item) => item.boardAttach === attachCd);
    const fileInfo = documentInfo?.attachFiles;

    if (!fileInfo) return;

    const param = encodeURIComponent(JSON.stringify(fileInfo));
    const fileUrl = `/common/zipDownload?fileList=${param}`;

    // 파일명 생성
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const filename = year + month + day + hours + minutes + '.zip';

    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Download failed');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url); // 메모리 정리
    } catch (error) {
      console.error('Download error:', error);
      alert('파일 다운로드에 실패했습니다.');
    }
  };

  useEffect(() => {
    // 초기 페이지 데이터 로드시키기
    handlePageChange(1);
  }, [documentList]);

  useEffect(() => {
    AOS.init();
    handleSearch();
  }, []);

  return (
    <>
      <section id="notice-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              자료실
            </h2>
            <p
              className="color-caption fs-md"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="200"
            >
              제품 및 서비스 관련 자료를 다운로드 할 수 있습니다.
            </p>
          </div>
        </div>
      </section>

      <main id="notice">
        <div className="notice-container m-auto">
          <div className="notice-search-box">
            <div className="notice-search">
              <input
                inputMode="search"
                type="text"
                placeholder="검색"
                name="searchDocumentTitle"
                value={searchDocumentTitle}
                onChange={handleChangeDocumentTitle}
                onKeyDown={handleKeyDown}
              />
              <button className="notice-search-btn" type="button" onClick={handleSearch}>
                <img src="./images/ico-notice-search.svg" alt="검색버튼" />
              </button>
            </div>
          </div>
          <div className="notice-table">
            <div className="notice-table-thead">
              <div className="notice-table-td01">번호</div>
              <div className="download-table-td">제목</div>
              <div className="download-btn-td">첨부파일</div>
              <div className="notice-table-td03">등록일</div>
            </div>
            {undefined !== currentPageDocument && currentPageDocument.length !== 0 ? (
              currentPageDocument.map((item, index) => (
                <div key={item?.boardSeq} className="notice-table-tbody">
                  <div className="notice-table-td01">{index + 1}</div>
                  <div className="download-table-td">
                    <Link to={`/document-detail?boardSeq=${item?.boardSeq}`}>
                      {item?.boardTitle}
                    </Link>
                  </div>

                  {undefined != item.attachFiles && item.attachFiles?.length !== 0 ? (
                    item.attachFiles?.length === 1 ? (
                      <div className="download-btn-td">
                        <button
                          className="download-table-btn"
                          onClick={(e) => handleFileDownload(item?.boardAttach)}
                        ></button>
                      </div>
                    ) : (
                      <div className="download-btn-td">
                        <button
                          className="download-table-btn"
                          onClick={(e) => handleZipDownload(item?.boardAttach)}
                        ></button>
                      </div>
                    )
                  ) : (
                    <div className="download-btn-td">
                      <button className="download-table-btn-disabled" disabled></button>
                    </div>
                  )}
                  <div className="notice-table-td03">{item?.regDt?.substring(0, 11)}</div>
                </div>
              ))
            ) : (
              <div className="notice-table-none">등록된 자료가 없습니다.</div>
            )}
          </div>

          {/* 페이지네이션 컴포넌트 */}
          <Pagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
          />
        </div>
      </main>
    </>
  );
}

export default Document;
